import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import selectHelper from '../../../../Helpers/selectHelper';

export default class VoidedThirdPartyJobPaymentsAdminSearchParams extends SearchParamsBase {
  initialize() {
    this.SearchType = 'Voided Payments';
    this.StatusCodeLookupValue = [];
    this.TypeText = [];
    this.Method = '';
    this.AssignmentType = '';
    this.TpEvaluatorNameOrId = '';
    this.TpEvaluatorEmail = '';
    this.ClientNameOrId = '';
    this.ProjectNameOrId = '';
    this.SelectedTpJobCountryCodes = [];
    this.SelectedPaymentOffices = [];
    this.SelectedThirdPartyJobStatuses = [];
    this.CreatedBy = '';
    this.EmptyPayment = '';
    this.TpEvaluatorTpJobPaymentId = '';
    this.AssignedTo = '';
    this.HasExportPayment = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'TpEvaluatorTpJobPaymentId', label: 'Pay ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'TpEvaluatorNameOrId', label: 'Evaluator Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'TpEvaluatorEmail', label: 'Evaluator Email', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ClientNameOrId', label: 'Client Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ProjectNameOrId', label: 'Project Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedTpJobCountryCodes',
      label: 'Country',
      className: 'col-4',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    {
      fieldName: 'SelectedPaymentOffices',
      label: 'Payment Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'TypeText',
      label: 'Type',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: VoidedThirdPartyJobPaymentsAdminSearchParams.getTypeTextSelectOptions(),
    },
    {
      fieldName: 'StatusCodeLookupValue',
      label: 'Status',
      options: 45,
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
    },
    {
      fieldName: 'SelectedThirdPartyJobStatuses',
      label: 'Third-Party Job Status',
      className: 'col-4',
      type: InputTypesEnum.TpJobStatusMultiSelect,
    },
    { fieldName: 'CreatedBy', label: 'Created By', className: 'col-4', type: InputTypesEnum.UserSelect },
    { fieldName: 'AssignedTo', label: 'Assigned To', className: 'col-4', type: InputTypesEnum.UserSelect },
    { fieldName: 'EmptyPayment', label: 'Empty Payment', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    {
      fieldName: 'HasExportPayment',
      label: 'Has Export Payment',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
  ];

  static getTypeTextSelectOptions() {
    return selectHelper.generateSelectValues([
      'Reprint',
      'Surcharge',
      'Refund',
      'Advance Payment',
      'Payment Request',
      'Assignment Payment',
    ]);
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'VoidedThirdPartyJobPaymentsAdminSearchParams';
}
